<template>
  <div class="breadcrumb">
    <div class="title">
      <h1>{{ $t(this.$route.name) }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="item in this.routes"
          :key="item.name"
          :to="getRouteTo(item)"
        >
          {{ $t(item.name) }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <slot />
    </div>
    <div class="button" v-if="this.$route.meta.button != null">
      <el-button type="success" @click="this.buttonClick">{{
        this.$route.meta.button.text
      }}</el-button>
    </div>
  </div>
</template>
<style scoped>
.breadcrumb { 
  display: block;
  width: 100%;
  height: 90px;
  background: #fff;
  border-top: 2px solid #eee;
  border-bottom: 1px solid #eee;
  position: relative;
  top: 0px;
  clear: both;
}
.breadcrumb >>> .el-breadcrumb__separator{
  margin: 0px 3px;
}
.title {
  display: block;
  height: 100%;
  padding-left: 15px;
  float: left;
}

.title h1 {
  padding: 0px;
  margin: 0px;
  font-size: 18px;
  height: 20px;
  line-height: 20px;
  margin: 20px 0px 15px;
}

.button {
  height: 100%;
  float: right; 
  line-height: 90px;
  padding-right: 15px;
}
</style>
<script>
export default {
  methods: {
    buttonClick() {
      this.$router.push({ path: this.$route.meta.button.path });
    },
    getRouteTo(item) {
      let params = Object.assign({}, this.$route.params);
      // {name: item.name, params: params}
      return { path: item.path };
    },
  },
  props: {
    title: { type: String, required: false },
    button: { type: String, required: false },
  },
  computed: {
    routes: function () {
      return this.$route.matched.filter(
        (item) => item.path !== "/main" && !item.meta.hideInBreadcrumb
      );
    },
  },
  filters: {
    pathFormat(path) {
      let params = path.match(new RegExp("/:[^/]+", "g"));
      for (let i = 0; i < params.length; i++) {
        path = path.replace(
          new RegExp(params[i], "g"),
          this.$route.params[params[i].replace("/:", "")]
        );
      }
      return path;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?e0e78280